export const topbar = {
    state: {
        menuMode: "static",
        overlayMenuActive: false,
        staticMenuDesktopInactive: false,
        staticMenuMobileActive: false,
    },
}